export default __webpack_public_path__ + "static/media/covid-19_tracking-dashboard_project-3.21c99d5b.png";